export default "__VITE_ASSET__DibgdHtq__"